export const anchorifyTextLinks = (text: string) => {
  const regex = /(https?:\/\/[^\s]+)/g
  const anchorify = (match: string) => {
    return `<a href="${match}" target="_blank">${match}</a>`
  }
  return text.replace(regex, anchorify)
}

// .replace(/(\w+\.\w+)/g, "<a href='$1' target='_blank'>$1</a>");
